import { Timestamp } from "firebase/firestore";

export function jobDataFromSnapshotDoc(id, job) {
  for (const prop in job) {
    if (job.hasOwnProperty(prop)) {
      if (job[prop] instanceof Timestamp) {
        job[prop] = job[prop].toDate();
      }
    }
  }

  return {
    ...job,
    id: id,
  };
}
